export default "__VITE_ASSET__BSzWXKeR__"